import { createTermsTagsManager } from '../../utils/createTermsTagsManager';

export const wordsExcludeTagsManager = createTermsTagsManager({
  jsonQueryKey: 'description_exclude',
  template: 'Не содержит "%s"',
  id: 'wordsExclude',
});
